import { Service } from "typedi";
import { IConfig } from "../../../shared/model/config/IConfig";
import { IGooglePayPaymentRequest } from "../../../integrations/google-pay/models/IGooglePayPaymentRequest";
import { hasDynamicPriceIntent } from "./GooglePayNativeCallbackIntents";

@Service()
export class GooglePayConfigMapper {
  createPaymentDataRequest(config: IConfig): IGooglePayPaymentRequest {
    const {
      apiVersion,
      apiVersionMinor,
      allowedPaymentMethods,
      merchantInfo,
      transactionInfo,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      shippingAddressRequired,
      callbackIntents,
      shippingAddressParameters,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      shippingOptionRequired,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      emailRequired,
    } = config.googlePay.paymentRequest;

    // Google Pay throws DEVELOPER_ERROR if displayItems is present
    // without dynamic price intents and their associated callbacks.
    const canIncludeDisplayItems = hasDynamicPriceIntent(callbackIntents);

    // An empty callbackIntents array triggers a SDK validation error
    // expecting paymentDataCallbacks on the client. Only include when populated.
    const hasIntents = (callbackIntents ?? []).length > 0;

    return {
      apiVersion,
      apiVersionMinor,
      allowedPaymentMethods,
      transactionInfo: {
        countryCode: transactionInfo.countryCode,
        currencyCode: transactionInfo.currencyCode,
        totalPriceStatus: transactionInfo.totalPriceStatus,
        totalPrice: transactionInfo.totalPrice,
        totalPriceLabel: transactionInfo.totalPriceLabel,
        ...(canIncludeDisplayItems && transactionInfo.displayItems
          ? { displayItems: transactionInfo.displayItems }
          : {}),
      },
      merchantInfo: {
        merchantName: merchantInfo.merchantName,
        merchantId: merchantInfo.merchantId,
        merchantOrigin: merchantInfo.merchantOrigin,
        authJwt: merchantInfo.authJwt,
      },
      shippingAddressRequired,
      shippingAddressParameters,
      shippingOptionRequired,
      emailRequired,
      ...(hasIntents ? { callbackIntents } : {}),
    };
  }
}
